module.exports = __webpack_public_path__ + "static/media/server-icon.3a665a9d.svg";